/** English strings — wave-4 maps: big fields, ADVANCE routes, gate notices (docs/01). */
export const enMaps = {
  // Big fields
  'arena.scrap-yard': 'Scrapyard',
  'arena.scrap-foundry': 'Foundry Floor',
  'arena.core-forge': 'The Forge',
  'arena.brood-nest': 'The Nest',
  'arena.rim-observatory': 'Observatory',
  'arena.rim-shardfield': 'Shard Field',
  // ADVANCE routes — ▶ marks a room you fight your way through
  'arena.scrap-spine': '▶ Freight Spine',
  'arena.scrap-dogleg': '▶ Dock Dogleg',
  'arena.core-conduit': '▶ Magma Conduit',
  'arena.core-switchback': '▶ Vent Switchback',
  'arena.brood-tunnel': '▶ Brood Tunnel',
  'arena.brood-gullet': '▶ The Gullet',
  'arena.rim-causeway': '▶ Rift Causeway',
  'arena.rim-spiral': '▶ Shard Spiral',
  'arena.core-crucible': '▶ Crucible Run',
  'arena.brood-warren': '▶ The Warren',
  'arena.rim-fracture': '▶ Fracture Line',
  // Gate notices
  'map.gateOpen': 'GATE OPEN!',
  'map.chamberOpen': 'BOSS CHAMBER!',
};
